import { ReactNode } from "react";
import { PublicFooter } from "@/components/common/PublicFooter";
import { PublicNav } from "@/components/common/PublicNav";

type Props = {
  kicker: string;
  title: string;
  children: ReactNode;
};

export function AuthShell({ kicker, title, children }: Props) {
  return (
    <div className="sa-page" style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <PublicNav />
      <div
        className="sa-auth-shell"
        style={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "80px 40px",
          position: "relative",
        }}
      >
        <div
          className="sa-auth-shell__card"
          style={{
            width: "100%",
            maxWidth: 420,
            background: "var(--sa-bg-pure)",
            border: "1px solid var(--sa-border)",
            padding: "48px 44px",
            position: "relative",
            borderRadius: 2,
          }}
        >
          <div className="sa-label" style={{ marginBottom: 14 }}>
            {kicker}
          </div>
          <h1
            style={{
              fontFamily: "var(--sa-serif)",
              fontWeight: 400,
              fontSize: 32,
              margin: "0 0 32px",
              letterSpacing: "-0.015em",
            }}
          >
            {title}
          </h1>
          {children}
        </div>
      </div>
      <PublicFooter />
    </div>
  );
}

type FieldProps = {
  label: string;
  type?: string;
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  autoComplete?: string;
  autoFocus?: boolean;
};

export function Field({
  label,
  type = "text",
  value,
  onChange,
  placeholder,
  autoComplete,
  autoFocus,
}: FieldProps) {
  return (
    <label style={{ display: "block", marginBottom: 18 }}>
      <div className="sa-label" style={{ marginBottom: 8 }}>
        {label}
      </div>
      <input
        className="sa-input"
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        autoComplete={autoComplete}
        autoFocus={autoFocus}
      />
    </label>
  );
}

export function FormError({ message }: { message: string }) {
  return (
    <div
      role="alert"
      style={{
        color: "var(--sa-danger)",
        fontFamily: "var(--sa-sans)",
        fontSize: 13,
        marginBottom: 16,
        padding: "10px 12px",
        background: "var(--sa-danger-bg)",
        border: "1px solid var(--sa-danger-border)",
        borderRadius: 2,
      }}
    >
      {message}
    </div>
  );
}
